import axios from "../../adminCompenents/config/axiosConfig";

export default class CategoryService {
  // 🔹 Récupérer toutes les catégories
  getAllCategories = async () => {
    try {
      const response = await axios.get("/categories");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des catégories : " + error.message
      );
    }
  };

  // 🔹 Créer une nouvelle catégorie
  createCategory = async (data) => {
    try {
      const response = await axios.post("/categories", data);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de la catégorie : " + error.message
      );
    }
  };

  // 🔹 Modifier une catégorie existante
  editCategory = async (id, data) => {
    try {
      const response = await axios.patch(`/categories/${id}`, data);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la modification de la catégorie : " + error.message
      );
    }
  };

  // 🔹 Activer / Désactiver une catégorie
  toggleCategoryStatus = async (id) => {
    try {
      const response = await axios.patch(`/categories/${id}/toggle-status`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors du changement de statut de la catégorie : " + error.message
      );
    }
  };

  // 🔹 Récupérer une catégorie par son ID
  getCategoryById = async (id) => {
    try {
      const response = await axios.get(`/categories/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération de la catégorie : " + error.message
      );
    }
  };

  // 🔹 Supprimer une catégorie (optionnel)
  deleteCategory = async (id) => {
    try {
      const response = await axios.delete(`/categories/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la suppression de la catégorie : " + error.message
      );
    }
  };
}
